<template>
  <div class="mobile-back-btn-secondary-nav-container">
    <router-link
      v-slot="{ href, route, navigate, isActive, isExactActive }"
      :to="{ name: 'FileList', params: { uuid: id } }"
    >
      <div @click="navigate" class="mobile-back-btn-secondary-nav">
        <i class="fa lh-inherit fa-arrow-left"></i> {{ translate('Back') }}
      </div>
    </router-link>
  </div>
</template>
<script>
import store from './../../../mixins/store.mixin';
import currentJob from './../../../mixins/current_job.mixin';

export default {
  name: "MobileBackBtnSecondaryNav",
  props: {},
  components: {},
  mixins: [
    store,
    currentJob
  ],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {},
  computed: {}
};
</script>
<style lang="scss" scoped>

.mobile-back-btn-secondary-nav-container {
  border-top: 1px solid #CBCBCB;
  background: white;
  padding: 10px 20px!important;

  .mobile-back-btn-secondary-nav {
    width: 100%;
    background: #1266F1;
    color: white;
    height: 55px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    gap: 10px;
    font-size: 17.5px;
    font-weight: 600;
    cursor: pointer;

    &:hover {
      background: #1161e5;
    }
  }
}
</style>
